import { InfoTestFieldCombinedProps } from './types';

const usePresenter = (props: InfoTestFieldCombinedProps): InfoTestFieldCombinedProps => {
  return props;
};

export default usePresenter;
